/**
 * DataBag class. Used to store and access data
 *
 * @class
 */
class DataBag {

    /**
     * DataBag constructor
     *
     * @param {object} data Object of data to store
     *
     * @constructor
     */
    constructor(data) {
        this.data = data || {};
    }

    /**
     * Gets a value safely
     *
     * @param {string}   path    The path to the data node
     * @param {*=}       initial The initial value of the data node
     *
     * @returns {*} Returns the value of the data node or the initial value
     */
    get = (path, initial = null) => {
        const len = path.length;

        let currentChar = '',
            currentKey = '',
            idx = 0,
            root = this.data;

        if (typeof path !== 'string') {
            return false;
        }

        if (path.indexOf('[') === -1) {
            return typeof root[path] === 'undefined' ? initial : root[path];
        }

        for (idx; idx < len; idx++) {
            currentChar = path.charAt(idx);

            if (currentChar === '[' || currentChar === ']') {
                if (currentKey !== '') {
                    if (!root || typeof root[currentKey] === 'undefined' || root[currentKey] === null) {
                        return initial;
                    }

                    root = root[currentKey];
                    currentKey = '';
                }
            } else {
                currentKey += currentChar;
            }
        }

        if (currentKey !== '' && typeof root[currentKey] !== 'undefined' && root[currentKey] !== null) {
            return root[currentKey] || initial;
        }

        return root || initial;
    };

    /**
     * Adds data to storage
     *
     * @param {object}         data Object of data to store
     * @param {string|boolean} path Path to store the data under, defaults to root
     */
    addData = (data, path = false) => {
        const len = typeof path === 'string' ? path.length : false;

        let currentChar = '',
            currentKey = '',
            idx = 0,
            root = this.data;

        // if we need to add the data to a path (not root)
        if (len) {
            for (idx; idx < len; idx++) {
                currentChar = path.charAt(idx);

                if (currentChar === '[' || currentChar === ']') {
                    if (currentKey !== '' && typeof root[currentKey] !== 'undefined' && root[currentKey] !== null) {
                        root = root[currentKey];
                        currentKey = '';
                    }
                } else {
                    currentKey += currentChar;
                }
            }

            if (currentKey !== '' && typeof root[currentKey] !== 'undefined' && root[currentKey] !== null) {
                root[currentKey] = Object.assign(root[currentKey], data);
            }
        } else {
            this.data = Object.assign(root, data);
        }
    };
}

export default DataBag;
